import { StyleSheet, Platform } from 'react-native';

import { isIPhoneDeviceWithNotch } from '@vfgroup-oneplatform/foundation/Utils/Platform';

const isIPhoneWithNotch = isIPhoneDeviceWithNotch();

export default StyleSheet.create({
  scrollViewContentContainer: {
    marginTop: Platform.OS === 'ios' ? (isIPhoneWithNotch ? 26 : 20) : 39,
  },
  percentageIndicatorContainerStyle: {
    marginTop: 8,
  },
  containerStyle: {
    marginHorizontal: 16,
    marginBottom: 80,
    marginTop: 23,
  },
  containerStyleWithTray: {
    marginBottom: Platform.OS === 'ios' ? 126 : 169,
  },
  chartUsageCardContainerStyle: {
    marginTop: 0,
    marginBottom: 17.4,
  },
  separator: theme => ({
    marginBottom: 16,
    borderBottomColor: theme.colors.borderColorThree,
    borderBottomWidth: 1,
  }),
  errorScreenBackgroundStyle: {
    height: 400,
  },
  iconStyle: {
    marginTop: 80,
  },
});
